import { render, staticRenderFns } from "./efficiency-class-icon.vue?vue&type=template&id=5f5b008d&"
import script from "./efficiency-class-icon.vue?vue&type=script&lang=js&"
export * from "./efficiency-class-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports